import React, { useState } from "react";
import shubinHeaderLogo from "../assets/shubinHeaderLogo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faInstagram,
  faSoundcloud,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { useLanguage } from "../context/LanguageContext";
import { useUI } from "../constants/i18n";
import InfoPopup from "./InfoPopup";

const Header: React.FC = () => {
  const { lang, toggleLanguage } = useLanguage();
  const ui = useUI(lang);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 w-full bg-[#000000]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">
        <div className="flex items-center">
          <a href="/" aria-label="Home">
            <img
              src={shubinHeaderLogo}
              className="header-logo h-10"
              alt="Shubin Project Logo"
            />
          </a>
        </div>
        <nav
          className="flex space-x-4 items-center"
          aria-label="Social media links"
        >
          <button
            onClick={() => setIsPopupOpen(true)}
            className="text-[#ebebeb] hover:text-[#C1282DFF] font-mono text-sm bg-transparent"
            aria-label="Show information about Shubin Project"
          >
            {ui.infoButton}
          </button>
          <InfoPopup
            isOpen={isPopupOpen}
            onRequestClose={() => setIsPopupOpen(false)}
          />
          <button
            onClick={toggleLanguage}
            className="text-[#ebebeb] hover:text-[#C1282DFF] font-mono text-sm tracking-widest bg-transparent"
            aria-label={`Switch to ${lang === "en" ? "Bulgarian" : "English"}`}
          >
            {lang === "en" ? "EN" : "BG"}
          </button>
          <a
            href="https://soundcloud.com/shubinproject"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our SoundCloud page"
          >
            <FontAwesomeIcon
              icon={faSoundcloud}
              className="h-6 w-6 text-[#ebebeb] hover:text-[#C1282DFF]"
            />
          </a>
          <a
            href="https://www.youtube.com/@shubinproject8941"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our YouTube channel"
          >
            <FontAwesomeIcon
              icon={faYoutube}
              className="h-6 w-6 text-[#ebebeb] hover:text-[#C1282DFF]"
            />
          </a>
          <a
            href="https://www.facebook.com/shubinproject"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our Facebook page"
          >
            <FontAwesomeIcon
              icon={faFacebookSquare}
              className="h-6 w-6 text-[#ebebeb] hover:text-[#C1282DFF]"
            />
          </a>
          <a
            href="https://www.instagram.com/shubin.project/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our Instagram page"
          >
            <FontAwesomeIcon
              icon={faInstagram}
              className="h-6 w-6 text-[#ebebeb] hover:text-[#C1282DFF]"
            />
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
